import { createReducer } from 'store/utils';
import { RootActions } from 'store/types';
import { actionsHandlers, stateFactories } from 'store/entities/utils';
import { EntityType } from 'store/entities/types';
import { OrganizationSettingsTranslation } from 'api/admin/models/OrganizationSettingsTranslation';
import * as actions from './actions';

const stateFactory = stateFactories.createInitialEntitiesStateFactory<EntityType<OrganizationSettingsTranslation>>();
const initialState = stateFactory.getInitialState();

type State = typeof initialState;
type Actions = RootActions<typeof actions>;

const adminOrganizationSettingsTranslationReducer = createReducer<State, Actions>(initialState, {
  [actions.getAdminOrganizationSettingsTranslation.request.type]: actionsHandlers.handleGetManyRequest,
  [actions.getAdminOrganizationSettingsTranslation.success.type]: actionsHandlers.handleGetManySuccess,
  [actions.getAdminOrganizationSettingsTranslation.failure.type]: actionsHandlers.handleGetManyFailure,
  [actions.getAdminOrganizationSettingsTranslation.reset.type]: actionsHandlers.handleGetManyReset,
  [actions.updateAdminOrganizationSettingsTranslation.request.type]: actionsHandlers.handleUpdateOneRequest,
  [actions.updateAdminOrganizationSettingsTranslation.success.type]: actionsHandlers.handleUpdateOneSuccess,
  [actions.updateAdminOrganizationSettingsTranslation.failure.type]: actionsHandlers.handleUpdateOneFailure,
  [actions.updateAdminOrganizationSettingsTranslation.reset.type]: actionsHandlers.handleUpdateOneReset,
});

export default adminOrganizationSettingsTranslationReducer;
